'use strict';

var index = require('./build/mocks/index.js');
var index$1 = require('./build/index.js');

var airbnbPropTypes = process.env.NODE_ENV === 'production' ? index : index$1;

module.exports = airbnbPropTypes;
